<template>
    <div class="FamilyDogDisplayAndEdit">
        <!--DISPLAY TABLE-->
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span>{{ props.rowData.Name }}</span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddDog()" class="pointer olive-green-text" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-dog" :title="ModalTitle" hide-footer modal-class="full-screen-modal">
            <b-container v-if="EditMode == false && TargetDog.Id">
                <b-row>
                    <b-col>
                        <h3>Pet Info</h3>
                        <p><span class="bold">Name: </span>{{ TargetDog.Name }}</p>
                        <p><span class="bold">Breed: </span>{{ TargetDog.Breed }}</p>
                        <p><span class="bold">Breed: </span>{{ formatDate(TargetDog.VaccinationsExpire,'MM/DD/YY') }}</p>
                    </b-col>
                    <b-col>
                        <h3>Assignment</h3>
                        <p><span class="bold">Start Date: </span>{{ formatDate(TargetDog.StartDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">End Date: </span>{{ formatDate(TargetDog.EndDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <CaseFile chart-type="DogFamilyMember"
                              :chart-record-id="TargetDog.Id" />
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelDog()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEditDog">
                    <b-row>
                        <b-col>
                            <h3>Pet Info</h3>
                            <div class="form-group">
                                <label>Name:</label>
                                <input class="form-control" v-model="TargetDog.Name" required />
                            </div>
                            <div class="form-group">
                                <label>Breed:</label>
                                <input class="form-control" v-model="TargetDog.Breed" required />
                            </div>
                            <div class="form-group">
                                <label>Vaccinations Expire:</label>
                                <flat-pickr v-model="TargetDog.VaccinationsExpire" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Assignment</h3>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetDog.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetDog.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="TargetDog.Id">
                        <b-col>
                            <h3>Add Document</h3>
                            <NewDocument :form-memberships="SubProgramDogFormMemberships"
                                         :chart-record-id="TargetDog.Id" />
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelDog()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteDog()" type="button" v-if="TargetDog.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import NewDocument from "../../../Core/RecordComponents/NewDocument.vue";
    import CaseFile from "../../../Core/RecordComponents/CaseFile.vue";

    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        props: [
            "EditMode",//bool
            "GlobalUpdate",//bool
            "DispatchOnSuccess",//string[]
            "GetEndpoint",//string
            "GetPayload",//object
            "AddEditEndpoint",//string
            "AddEditPayload",//object
            "DeleteEndpoint",//string
            "DeletePayload",//object
            "DeleteWarning",//string
            "FamilyRecordData"
        ],
        data: function () {
            return {
                TableFields: [
                    {
                        name: "__slot:DetailView",
                        title: "NAME"
                    },
                    {
                        name: "Breed",
                        title: "BREED"
                    },
                    {
                        name: "VaccineExpirationDate",
                        title: "VACCINES EXPIRE",
                        callback: 'formatDate|MM/DD/YY|NONE ON FILE'
                    },
                    {
                        name: "StartDate",
                        title: "STARTED",
                        callback: 'formatDate|MM/DD/YY'
                    },
                    {
                        name: "EndDate",
                        title: "ENDED",
                        callback: 'formatDate|MM/DD/YY'
                    }
                    
                ],
                TargetDog: {},
                ModalTitle: "",
                LoadedRecords: [],//Dog Records
                DogSchema: {
                    Id: "",
                    StartDate: "",
                    EndDate: "",
                    Name: "",
                    Breed: "",
                    VaccinationsExpire: ""
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false  
                }
                
            };
        },
        methods: {
            onRowClass (dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            GetDogs() {
                this.$MasterAPI.ExecuteRequest("GET", this.GetEndpoint, this.GetPayload, this.GetDogsSuccess, () => { }, false);
            },
            GetDogsSuccess(response) {
                this.LoadedRecords = response.data.data;
            },
            ShowDetailView(dog) {
                this.TargetDog = JSON.parse(JSON.stringify(dog));
                
                if (this.EditMode) {
                    this.ModalTitle = "Editing " + dog.Name;
                } else {
                    this.ModalTitle = "Viewing " + dog.Name;
                }
                this.$refs["modal-dog"].show();
            },
            ShowAddDog() {
                this.TargetDog = JSON.parse(JSON.stringify(this.DogSchema));
                this.ModalTitle = "Add New Pet";
                this.$refs["modal-dog"].show();
            },
            AddEditDog(e) {
                e.preventDefault();
                //get person data here
                this.$MasterAPI.ExecuteRequest("POST", this.AddEditEndpoint,  { ...this.TargetDog, ...this.AddEditPayload }, this.AddEditDogSuccess, () => { }, true);
            },
            AddEditDogSuccess(response) {
                this.GetDogs();
                this.$refs["modal-dog"].hide();
            },
            DeleteDog() {
                this.$MasterAPI.ExecuteRequest("POST", this.DeleteEndpoint,  { Id: this.TargetDog.Id }, this.DeleteDogSuccess, () => { }, true);
            },
            DeleteDogSuccess(response) {
                this.GetDogs();
                this.$refs["modal-dog"].hide();
            },
            CancelDog() {
                this.$refs['modal-dog'].hide();
            },
            formatDate (value, fmt = 'D MMM YYYY', defaultVal = '') {
              return (value == null || value == '')
                ? defaultVal
                : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            Vuetable,
            NewDocument,
            CaseFile
        },
        computed: {
            TableData: function () {
                return this.LoadedRecords;
            },
            SubProgramDogFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.FamilyRecordData.FamilyProgramMembership.SubProgramID);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "DogFamilyMember");
            }
        },
        mounted() {
            this.GetDogs();
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr.current-record {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>